module.exports = __webpack_public_path__ + "static/media/5S.74c699bb.svg";